import React from "react";
import "../../pages/services/services.css";

import { Link } from "react-router-dom";

import { Box, Container, Grid, TextField, Button } from "@mui/material";
import PoojaBasket from "../../components/common/Basket/PoojaBoasket/PoojaBasket";
import { logEvent } from "../../utils/analytics";
import templeJson from "../../config/temple.json";
import useDonationData from "./customHook";

function Donations() {
  const {
    donationData,
    donationAmount,
    errorMessage,
    handleDonationAmount,
    handleAddDonations,
  } = useDonationData();

  const isStyleOne = templeJson["Services"]?.style === 1;
  const servicestyle = {
    head: isStyleOne ? "page-header py-4 service-head-dt" : "page-header py-4 service-head-svt",
  };

  return (
    <>
      <Container maxWidth="xl" className={servicestyle?.head}>
        <h1 className="text-center service-head display-6 breadcrumb-h1">Donation</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Services</Link>
          </li>
          <li className="breadcrumb-item active">Donation</li>
        </ol>
      </Container>

      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            {templeJson["templeName"]}
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Donation</span>
          </h1>
        </Grid>

        <Grid container spacing={2}>
          <Grid item lg={9} md={8} sm={12}>
            <Grid container className="room-item m-0 mb-4">
              <Grid item lg={4} md={12} sm={12} className="p-0 img-ser-detail">
                <Box className="h-100">
                  <img
                    className="img-ser-detail"
                    src={donationData?.image}
                    alt={donationData?.title}
                  />
                </Box>
              </Grid>

              <Grid item lg={8} md={12} sm={12} className="h-100 px-0">
                <Grid p={4}>
                  <Grid display="flex" justifyContent="space-between" alignItems="center">
                    <h5 className="service-title">{donationData?.title} {donationData?.amount}</h5>
                  </Grid>

                  <Grid display="flex" justifyContent="space-between" className="border-bottom mt-auto pb-3">
                    <TextField
                      className="me-2"
                      value={donationAmount[donationData?._id] || ""}
                      onChange={(e) => handleDonationAmount(donationData, e)}
                      label="Donation in $"
                      id="outlined-size-normal"
                      error={!!errorMessage}
                      helperText={errorMessage}
                    />

                    <Button
                      variant="contained"
                      color="primary"
                      className="text-white"
                      onClick={() => {
                        handleAddDonations(donationData);
                        logEvent("Donation", "Request for donation", `${donationData.title}`);
                      }}
                      disabled={!!errorMessage}
                    >
                      Add to Basket
                    </Button>
                  </Grid>

                  <p className="text-body mb-0 mt-3">{donationData?.description}</p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Basket Section */}
          <Grid item lg={3} md={4} sm={12}>
            <PoojaBasket />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Donations;
